module.exports = __webpack_public_path__ + "img/mini_store.2fc4c29c.jpg";